import { Download1Stroke, EyeStroke, Pencil1Stroke, PlusStroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { FileDown, RefreshCw, Table } from 'lucide-react';
import { ActionBarV2, ActionButtonV2, MenuButtonV2 } from '@/components/custom/erp';

export interface ActionBarProps {
  onAddClick: () => void;
  onEditClick: () => void;
  onDeleteClick: () => void;
  onCopyClick: () => void;
  onViewClick: () => void;
  onRefreshClick?: () => void;
  isEditDisabled?: boolean;
  isViewDisabled?: boolean;
  isDeleteDisabled?: boolean;
  isCopyDisabled?: boolean;
}

export const ActionBar = ({
  onAddClick,
  onEditClick,
  onDeleteClick,
  onCopyClick,
  onViewClick,
  onRefreshClick,
  isEditDisabled = false,
  isViewDisabled = false,
  isDeleteDisabled = false,
  isCopyDisabled = false
}: ActionBarProps) => (
  <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Danh mục thuế suất</h1>}>
    <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddClick} variant='primary' />
    <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditClick} disabled={isEditDisabled} />
    <ActionButtonV2
      icon={Trash3Stroke}
      title='Xoá'
      variant='destructive'
      onClick={onDeleteClick}
      disabled={isDeleteDisabled}
    />
    <ActionButtonV2 icon={Download1Stroke} title='Sao chép' onClick={onCopyClick} disabled={isCopyDisabled} />
    <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onViewClick} disabled={isViewDisabled} />
    <MenuButtonV2
      title='Khác'
      items={[
        {
          title: 'Refresh',
          icon: RefreshCw,
          onClick: onRefreshClick || (() => {}),
          group: 0
        },
        {
          title: 'Cố định cột',
          icon: Table,
          onClick: () => {},
          group: 0
        },
        {
          title: 'Kết xuất dữ liệu',
          icon: FileDown,
          onClick: () => {},
          group: 1
        }
      ]}
    />
  </ActionBarV2>
);
